import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Website from "./pages/Website";
import Website2 from "./pages/Website2";
import Businesses from "./pages/Businesses";
import Contact from "./pages/Contact";
import ScrollToTop from "./components/ScrollToTop";

function App() {
    return (
        <BrowserRouter>
            <ScrollToTop/>
            <Routes>
                <Route path="/" element={<Website2 />} />
                {/*<Route path="/businesses" element={<Businesses />} />*/}
                <Route path="/contact" element={<Contact />} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
